import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";

const HrmCtaBanner: React.FC = () => {
  return (
    <section className="wdev-cta hrm-cta" aria-labelledby="hrm-cta-title">
      <div className="container">
        <AnimatedSection>
          <motion.div className="wdev-cta__inner" whileHover={{ scale: 1.005 }} transition={{ duration: 0.3 }}>
            <div className="wdev-cta__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="8" r="4" stroke="#2563eb" strokeWidth="1.5" />
                <path d="M4 20c0-4 3.5-7 8-7s8 3 8 7" stroke="#2563eb" strokeWidth="1.5" />
              </svg>
            </div>
            <div className="wdev-cta__text">
              <h2 id="hrm-cta-title" className="wdev-cta__title">
                Ready to Streamline Your HR Operations?
              </h2>
              <p className="wdev-cta__subtitle">
                Get a demo of our HRM software — payroll, attendance, leave, recruitment, and
                performance in one platform.
              </p>
            </div>
            <Link to="/contact" className="wdev-cta__btn">
              Request a Demo
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <path
                  d="M3 8h10M9 4l4 4-4 4"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Link>
          </motion.div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default HrmCtaBanner;
